/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.service('CmdService', ["$rootScope", function ($rootScope) {


        var getErrors = function()
        {
            var logArray = localStorage.getItem("errorArray")
            logArray = JSON.parse(logArray)
            return logArray;
        }
        
        var getLogs = function()
        {
            var logArray = localStorage.getItem("logArray")
            logArray = JSON.parse(logArray)
            return logArray;
        }

        return {
            getErrors: getErrors,
            getLogs:getLogs
        };

    }]);